import React, { Component } from 'react'
import moment from 'moment'
import { isEmpty } from 'lodash'
import { SingleDatePicker } from 'react-dates'

import 'react-dates/lib/css/_datepicker.css'
import './date-picker.css'

class DatePicker extends Component {
  constructor (props) {
    super(props)
    this.state = {
      focused: false
    }
  }

  render () {
    const date = isEmpty(this.props.date) ? moment(moment().format('YYYY-MM-DD')) : moment(this.props.date)
    return (
      <SingleDatePicker
        date={date}
        onDateChange={this.props.onDateChange}
        focused={this.state.focused}
        onFocusChange={({ focused }) => this.setState({ focused })}
        numberOfMonths={1}
        showDefaultInputIcon
        disabled={this.props.disabled}
      />
    )
  }
}

export default DatePicker



// WEBPACK FOOTER //
// ./src/components/DatePicker/index.js